// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__2o9l2","wrapper-nopadding":"wrapper-nopadding__1F5FM","loading":"loading__uAMCl","error":"error__3QMLM","table-loading":"table-loading__3BfE0","empty-val":"empty-val__1dBuh","panelheader-tools":"panelheader-tools__28VLY","propsPanels":"propsPanels__1k_Vi","new":"new__3Enen","marginLm":"marginLm__hQmGg","marginRm":"marginRm__1jZc-","fullWidth":"fullWidth__3Ljky","fullHeight":"fullHeight__2XsTC","noData":"noData__xlvBW"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Gateway/coms/GatewayDetail/coms/LogView/styles/main.scss
// module id = 2274
// module chunks = 1